import { CodeEventValidity } from 'domain/codeEvent/CodeEventValidity';

export interface RestCodeEventValidity {
  isConsumable: boolean;
}

export function toCodeEventValidity(restCodeEventValidity: RestCodeEventValidity) {
  return new CodeEventValidity(restCodeEventValidity.isConsumable);
}
